import { BaseModel } from '@tcc-mono/shared/data-access';

/** Subset van TransportGroup zoals teruggegeven in AnimalDetailsResponse */
export interface TransportGroupAnimalDetails {
  id?: number;
  date?: string | null;
  hub_name?: string | null;
  destination_stable_name?: string | null;
  destination_stable_ubn?: string | null;
  vehicle_license_plate?: string | null;
  animal_count?: number | null;
  type?: string | null;
  avg_weight: number | null;
  avg_purchase_price: number | null;
  closed?: boolean | null;
}

export class TransportGroup extends BaseModel {
  created_at?: string;
  animal_count?: number;
  avg_weight?: number | null;
  avg_purchase_price?: number | null;
  bright_exported_at?: string;
  closed?: boolean;
  date?: string;
  destination_hub_id?: number;
  destination_hub_name?: string;
  destination_hub_ubn?: string;
  destination_stable_id: number;
  destination_stable_company: string;
  destination_stable_company_id: number;
  destination_stable_name: string;
  destination_stable_ubn: string;
  destination_stable_rvo_number: string;
  /** Bestemmingstal heeft volledige RVO-credentials (aanvoer mogelijk). */
  destination_can_register_rvo?: boolean;
  /** Bestemmingstal neemt deel aan Vitaal Kalf (KVS-melding verwacht). */
  destination_vitaal_kalf_participant?: boolean;
  estimated_time_of_arrival: string;
  finished_at?: string;
  hub_id: number;
  hub_name?: string;
  id: number;
  remarks?: string;
  type?: string;
  min_age?: number;
  max_age?: number;
  setup_code_id?: number;
  setup_code_code?: string;
  vehicle_id?: number;
  vehicle_license_plate?: string;
  max_weight?: number;
  gender_id?: number;
  departure_registered: boolean;
  arrival_registered: boolean;
  sales_invoice_line_id: number;
  do_not_invoice: boolean;
  animal_transfer_mail_sent?: string;
  transport_id?: number;
  kvs_departure_registered_at?: string;
  kvs_departure_message_status?: string;
  is_project?: boolean;
}

export class TransportGroupRemainingAnimals {
  source_hub_id: number;
  destination_hub_id: number;
  vehicle_id: number;
}

export interface OtherGroupWithoutVehicle {
  id: number;
  destination_stable_name: string;
  destination_stable_company: string;
  animal_count: number;
}

export interface CreateTransportErrorResponse {
  message: string;
  other_groups_without_vehicle: OtherGroupWithoutVehicle[];
  override_available: boolean;
}

export class TransportGroupRvoReportResult {
  country_code: string;
  earmark: string;
  errormessage: string;
  success: boolean;
}


export class GroupedTransportLists {
  vehicle_id?: number;
  datum: string;
  kenteken: string;
  bestemming: string;
  ubn: string;
  aantal_groepen: number;
  totaal_aantal_dieren: number;
  groepen: TransportGroup[];
}

export type TransportGroupDayCheckConditionType =
  | 'price_above'
  | 'price_below'
  | 'weight_above'
  | 'weight_below'
  | 'price_per_kg_above'
  | 'price_per_kg_below'
  | 'outside_spec'
  | 'project_mismatch'
  | 'unhealthy'
  | 'has_remarks';

export type TransportGroupDayCheckSpecAspect = 'weight' | 'color' | 'gender' | 'age';

export interface TransportGroupDayCheckCondition {
  type: TransportGroupDayCheckConditionType;
  value?: number | null;
  aspects?: TransportGroupDayCheckSpecAspect[] | null;
}

export interface TransportGroupDayCheckFilterGroup {
  conditions: TransportGroupDayCheckCondition[];
}

export interface TransportGroupDayCheckParams {
  date: string;
  groups: TransportGroupDayCheckFilterGroup[];
}

export interface TransportGroupDayCheckReason {
  code: string;
  label: string;
}

export interface TransportGroupDayCheckAnimal {
  id: number;
  country_code: string;
  identification_number: string;
  weight: number | null;
  price: number | null;
  price_per_kg: number | null;
  purchase_order_id: number | null;
  color_code: string | null;
  color_name: string | null;
  gender_id: number | null;
  gender_name: string | null;
  date_of_birth: string | null;
  is_project: boolean;
  is_healthy: boolean | null;
  not_healthy_reason_name: string | null;
  remarks: string | null;
  reasons: TransportGroupDayCheckReason[];
}

export interface TransportGroupDayCheckGroup {
  id: number;
  date: string;
  hub_id: number;
  hub_name: string | null;
  destination_stable_name: string | null;
  destination_stable_company: string | null;
  destination_hub_name: string | null;
  vehicle_license_plate: string | null;
  type: string | null;
  gender_id: number | null;
  gender_name: string | null;
  is_project: boolean;
  max_weight: number | null;
  min_age: number | null;
  max_age: number | null;
  animal_count: number;
  animals: TransportGroupDayCheckAnimal[];
}

export interface TransportGroupDayCheckResult {
  date: string;
  animal_count: number;
  group_count: number;
  groups: TransportGroupDayCheckGroup[];
}

